// import SecureStorage from "../../utils/secureStorage";
import fetchApi from "../fetchApi";
export const GetCurrentUser = async () => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi("auth/current-user", options);
};